module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    attrs: {
      "show-close": false,
      "isBgOverlay": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v("Åbningstider")])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('table', {
    staticClass: "d-table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Dag")]), _vm._v(" "), _c('th', [_vm._v("Åbner")]), _vm._v(" "), _c('th', [_vm._v("Lukker")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.openingHours), function(time, day) {
    return _c('tr', {
      key: day
    }, [_c('td', [_vm._v(_vm._s(_vm.getDayName(day)))]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (time.open),
        expression: "time.open"
      }],
      attrs: {
        "type": "time"
      },
      domProps: {
        "value": (time.open)
      },
      on: {
        "change": function($event) {
          return _vm.formatTime(day, 'open')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(time, "open", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (time.close),
        expression: "time.close"
      }],
      attrs: {
        "type": "time"
      },
      domProps: {
        "value": (time.close)
      },
      on: {
        "change": function($event) {
          return _vm.formatTime(day, 'close')
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(time, "close", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: false,
          placement: 'right'
        }),
        expression: "{\n                  arrow: false,\n                  placement : 'right'\n                }"
      }],
      staticClass: "icon__bg-circle icon__bg-circle--danger",
      attrs: {
        "content": 'Slet'
      },
      on: {
        "click": function($event) {
          return _vm.deleteDay(day)
        }
      }
    }, [_c('span', {
      staticClass: "icon-bin"
    })])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "do-modal__footer"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSaving
    },
    on: {
      "click": _vm.saveOpeningHours
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-60a5ecdf!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DutySchedule/DutyScheduleOpeningHours.vue
// module id = 1673
// module chunks = 1